<template>
<div class="vertical-table">
  <table class="vt-head" :style="{width:tableConfig.theadWidth + 'px'}">
    <slot name="vt-head"></slot>
  </table>
  <table class="vt-body" :style="{left:tableConfig.theadWidth + 'px'}" v-if="tableData && tableData.length > 0">
    <slot name="vt-body"></slot>
  </table>
  <div class="msg" v-else :style="{left:tableConfig.theadWidth + 'px'}">
    <p>暂无数据</p>
  </div>
</div>
</template>
<script>
  export default {
    props:['tableData','tableConfig'],
    name:'VerticalTable',
    data(){
      return{}
    }
  }
</script>
<style lang="scss">
  .vertical-table{
    position: relative;
    width: 100%;
    overflow-x: scroll;
    table
    {
      border-collapse:collapse;
    }
    table,th, td
    {
      border: 1px solid #E1E5E7;
    }
    .vt-head{
      position: sticky;
      left: 0;
      top: 0;
      table-layout: fixed;
      z-index: 3;
      th{
        padding: 1px 15px;
        height: 30px;
        line-height: 30px;
        font-weight: 400;
        text-align: right;
        background-color: #EFF3F6;
      }
    }
    .vt-body{
      position: absolute;
      top: 0;
      table-layout: fixed;
      z-index: 1;
      td{
        padding: 1px 15px;
        height: 30px;
        min-width: 100px;
        line-height: 30px;
        white-space: nowrap;
        .el-input__inner{
          height: 28px;
          line-height: 28px;
          font-size: 12px;
        }
        .el-input{
          .el-input__icon{
            line-height: 28px;
          }
        }
      }
    }
    .msg{
      display: flex;
      box-sizing: border-box;
      position: absolute;
      top: 0;
      width: 300px;
      height: 100%;
      border: 1px solid #E1E5E7;
      background-color: #F8FAFB;
      justify-content: center;
      align-items: center;
      p{
        font-size: 18px;
        font-weight: bold;
        color:rgba(0,0,0,0.3);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/basics/verticalTable.vue